import React from 'react';
import CSSModules from 'react-css-modules';
import PropTypes from 'prop-types';
import styles from './styles.scss';

const ApiResult = ({ message, isError }) => {
  const style = isError ? 'api-result-error' : 'api-result-succeeded';
  if (message) {
    return (
      <div styleName={style}>
        <span>{message}</span>
      </div>
    );
  }
  return null;
};

ApiResult.propTypes = {
  message: PropTypes.string,
  isError: PropTypes.bool,
};

ApiResult.defaultProps = {
  message: '',
  isError: false,
};

export default CSSModules(ApiResult, styles);
